module.exports = __webpack_public_path__ + "assets/img/Structure_item2.cf6a005b.png";